export default __webpack_public_path__ + "static/media/DanhsachHDNT.be514b31.docx";